import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: "root"
})
export class LocationService {
  public urlChanged = new Subject();

  constructor(private location: Location) {
	// This is a shared service so the code only gets called once
	this.location.onUrlChange((url, state) => {
	  this.urlChanged.next({ url, state });
	});
  }
}
